<template>
    <nav class="menu">
        <template v-if="latestAlbums">
            <h4 class="menu__caption">
                <span class="material-icon icon-collections"></span>
                {{ $t('latest_albums') }}
            </h4>
            <ul v-if="latestAlbums.length > 0" class="menu__list">
                <li v-for="(item, i) in latestAlbums" :key="i" class="menu__item">
                    <router-link :to="i18nLink(`album/gallery/${item.id}`)">
                        {{ item.title || $t('no_title') }}
                        <span class="menu__counter">({{ item.total_pictures }})</span>
                    </router-link>
                </li>
            </ul>
            <div v-else class="alert alert-info">{{ $t('no_data') }}</div>
        </template>
        <div v-else>{{ $tc('loading', 2) }}</div>
    </nav>
</template>

<script>
  import menuLatestAlbums from 'src/mixins/menuLatestAlbumsComponent';

  export default {
    mixins: [menuLatestAlbums],
  };
</script>